import { createContext } from 'react';

import type { QueryAction } from '@/sections/insights/queryBuilder/types/QueryActions';
import type { QueryState } from '@/sections/insights/queryBuilder/types/QueryState';
import type { SavedQuery } from '@/sections/insights/queryBuilder/types/SavedQuery';

/**
 * Context value type
 */
export type QueryDataContextValue = {
  queryState: QueryState | null;
  dispatch: (action: QueryAction) => void;
  getSavedQuery: () => SavedQuery | null;
};

export const QueryDataContext = createContext<QueryDataContextValue | null>(
  null
);
